export default __webpack_public_path__ + "static/media/left_learn_more.0a6cde13.svg";